var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconCommentFilled = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.53c0 4.713-4.7 8.532-10.5 8.532-1.521 0-2.965-.263-4.269-.734-.488.356-1.284.844-2.227 1.255-.984.426-2.17.791-3.347.791a.657.657 0 0 1-.467-1.12l.012-.012a4.86 4.86 0 0 0 .254-.291c.169-.205.394-.509.624-.886.41-.68.8-1.575.878-2.58C3.728 16.091 3 14.381 3 12.531c0-4.713 4.7-8.531 10.5-8.531C19.3 4 24 7.818 24 12.53z",
    fill: "#3E704B",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCommentFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-comment-filled.9c8638b4.svg";
export { ForwardRef as ReactComponent };